import React, { useState } from 'react';
import { useSimulation } from '../context/SimulationContext';
import Card from '../components/common/Card';
import Table from '../components/common/Table';
import LogItem from '../components/mobile/LogItem';
import { formatDateTime } from '../utils/formatters';
import { LOG_LEVEL_COLORS } from '../utils/constants';
import useIsMobile from '../hooks/useIsMobile';

const LogsPage = () => {
  const { logs } = useSimulation();
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const isMobile = useIsMobile();

  const filteredLogs = logs.filter(log => {
    const matchesFilter = filter === 'all' || log.level === filter;
    const matchesSearch = log.message.toLowerCase().includes(search.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const columns = [
    { header: '시간', accessor: 'timestamp', render: (row) => formatDateTime(row.timestamp) },
    { header: '레벨', accessor: 'level', render: (row) => (
      <span className={LOG_LEVEL_COLORS[row.level]}>{row.level}</span>
    )},
    { header: '카테고리', accessor: 'category' },
    { header: '메시지', accessor: 'message' },
  ];

  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="text-2xl sm:text-3xl font-bold">시스템 로그</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
        <Card>
          <div className="text-sm text-gray-400 mb-2">API 연결</div>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
            <span className="text-green-500 font-semibold">정상</span>
          </div>
        </Card>
        <Card>
          <div className="text-sm text-gray-400 mb-2">CPU 사용률</div>
          <div className="text-2xl font-bold">23%</div>
        </Card>
        <Card>
          <div className="text-sm text-gray-400 mb-2">메모리 사용률</div>
          <div className="text-2xl font-bold">45%</div>
        </Card>
      </div>

      <Card>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0 mb-4">
          <div className="flex space-x-1 sm:space-x-2">
            {['all', 'INFO', 'WARNING', 'ERROR'].map((level) => (
              <button
                key={level}
                onClick={() => setFilter(level)}
                className={`px-2 sm:px-4 py-2 rounded-lg text-xs sm:text-base ${filter === level ? 'bg-blue-500 text-white' : 'bg-gray-700 text-gray-400'}`}
              >
                {level === 'all' ? '전체' : level}
              </button>
            ))}
          </div>
          <input
            type="text"
            placeholder="로그 검색..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="input w-full md:max-w-xs text-sm sm:text-base"
          />
        </div>

        {/* 로그 리스트 - 모바일/데스크톱 분기 */}
        {isMobile ? (
          <div className="max-h-96 overflow-y-auto">
            {filteredLogs.slice(0, 50).map((log, index) => (
              <LogItem key={index} log={log} />
            ))}
          </div>
        ) : (
          <Table columns={columns} data={filteredLogs.slice(0, 50)} />
        )}
      </Card>
    </div>
  );
};

export default LogsPage;
